import React from 'react';
import { useTranslation } from 'react-i18next';
import { Download, Loader2 } from 'lucide-react';
import type { ReferenceImage } from '../../api/imagePresets';
import { useReferencePreview } from '../../hooks';
import { Modal } from './common';
import { CHECKERBOARD, formatBytes } from './format';

/** 참조 이미지를 원본 비율로 크게 보여 주고 받을 수 있게 한다. */
const ReferenceViewer: React.FC<{ image: ReferenceImage; onClose: () => void }> = ({ image, onClose }) => {
  const { t } = useTranslation();
  const url = useReferencePreview(image.name, image.sha256);

  return (
    <Modal title={image.name} onClose={onClose} wide>
      <div className={`${CHECKERBOARD} rounded-lg flex items-center justify-center min-h-[16rem]`}>
        {url ? (
          <img src={url} alt={image.name} className="max-h-[70vh] max-w-full object-contain" />
        ) : (
          <Loader2 className="animate-spin text-slate-300" />
        )}
      </div>
      <div className="mt-3 flex items-center justify-between gap-3 text-xs text-slate-500">
        <span>
          {image.mime.replace('image/', '').toUpperCase()} · {formatBytes(image.size)}
        </span>
        {url && (
          <a href={url} download={image.name} className="btn-secondary text-sm inline-flex items-center gap-1.5">
            <Download size={15} /> {t('imagePresets.download')}
          </a>
        )}
      </div>
    </Modal>
  );
};

export default ReferenceViewer;
